import Role, { ROLE_RANK } from "../enums/Role";

export function hasRoleAtLeast(
  role: Role | string | null | undefined,
  minRole: Role,
): boolean {
  if (!role) return false;
  const roleRank = ROLE_RANK[role as Role];
  const minRank = ROLE_RANK[minRole];
  if (roleRank === undefined || minRank === undefined) return false;
  // Lower rank number = higher authority, so "at least minRole" means rank <= minRank.
  return roleRank <= minRank;
}
